import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Force scroll to top immediately on mount (for direct URL entry)
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // If there's a hash (anchor link), scroll to that section
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // No hash, scroll to absolute top of page immediately
      window.scrollTo(0, 0);
      // Force it again after a small delay to ensure it takes effect
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 50);
    }
  }, [pathname, hash]);

  return null;
}
